import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class BillingMixin extends Vue {
  formattedDate(date){
    return moment.unix(date).format('DD MMMM YYYY') + ' UTC';
  }

  get nextBillingAt(){
    return moment.unix(this.$store.state.billing.subscriptionStart).add(1, 'month').unix()
  }

  get nextBillingEnd(){
    return moment.unix(this.$store.state.billing.subscriptionEnd).add(1, 'month').unix()
  }
} 
